// A dashboards preview (OPERATORS_DASHBOARDS_PREVIEW=1) serves the app for
// dashboards work only: no Operator sessions, and no websocket to the control
// plane. Dashboards are plain HTTP against /api, so nothing here needs one.
//
// This is a build-time flag rather than a server flag because a preview builds
// and serves its own bundle per session, and the vite config already decides
// preview-ness at that point. It is not a security boundary -- the control
// plane still authorizes every request -- it only keeps the UI from reaching
// for a transport the preview deliberately does not proxy.
export function isDashboardsOnly(): boolean {
  return import.meta.env.VITE_DASHBOARDS_ONLY === "1";
}

export const DASHBOARDS_INDEX_PATH = "/dashboards" as const;
